module.exports = __webpack_public_path__ + "static/media/not-found.7cbb9dd8.png";